import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { OpenModalHookType } from '@hooks/useOpenModal';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Calculator from '@components/Utilities/Calculator';
import { currencyFormatter } from '@utils/Numbers';
interface ModalCreditCardCalculatorProps {
    modalCreditCardCalculator: OpenModalHookType;
    total: number;
    onAddCreditCardAmount: (amount: number) => void;
}
export const ModalCreditCardCalculator: React.FunctionComponent<ModalCreditCardCalculatorProps> = (props: any) => {
    const { modalCreditCardCalculator, total, onAddCreditCardAmount } = props;
    const [amount, setAmount] = useState<number>(0);
    const [totalAmount, setTotalAmount] = useState<boolean>(false);

    const handleClose = () => {
        setAmount(0);
        modalCreditCardCalculator.toggle();
    };
    const onDone = () => {
        handleClose();
        onAddCreditCardAmount(amount);
    };

    return (
        <Dialog
            PaperProps={{
                style: { borderRadius: 15, padding: 4 }
            }}
            open={modalCreditCardCalculator.modalOpen}
            onClose={handleClose}
            aria-labelledby="modal-credit-card-calculator-title"
            aria-describedby="modal-credit-card-calculator-description"
            fullWidth
            maxWidth="xs"
        >
            <DialogTitle id="modal-credit-card-calculator-title">
                <Stack direction="row" justifyContent="flex-end" alignItems="center">
                    <IconButton color="secondary" onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <Stack alignItems="center" spacing={2}>
                    <Typography>Monto recibido</Typography>
                    <Stack direction="row" alignItems="center">
                        <Checkbox
                            checked={totalAmount}
                            onChange={() => {
                                setAmount(total);
                                setTotalAmount(!totalAmount);
                            }}
                        />
                        <Typography variant="body1">Monto total</Typography>
                    </Stack>
                    <Typography variant="h3" fontWeight={600}>
                        {currencyFormatter(amount)}
                    </Typography>
                    <Calculator disabled={totalAmount} showAmount={false} onChangeValue={setAmount} />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button disabled={amount === 0} fullWidth onClick={onDone} color="success" variant="contained">
                    Agregar
                </Button>
            </DialogActions>
        </Dialog>
    );
};
